import { DownOutlined } from '@ant-design/icons'
import { Space, Spin, Tag, Tree, Typography } from 'antd'
import { FC, useEffect, useState } from 'react'
import { Sponsorship } from '../../models/Sponsorship'
import { getReferred } from '../../services/UserService'
import { useAppSelector } from '../../store/hooks'
import { selectUserById } from '../../store/UserReducer'
import { User } from './User'
const { Text } = Typography
interface Props {
  userId: number
}

const LoyaltyReferredUsers: FC<Props> = ({ userId }) => {
  const user = useAppSelector(selectUserById(userId))
  const [data, setData] = useState<Sponsorship[]>([])
  const [isLoading, setIsLoading] = useState<boolean>(false)

  useEffect(() => {
    setIsLoading(true)
    getReferred(userId)
      .then((result) => {
        setData(result)
      })
      .finally(() => setIsLoading(false))
  }, [])

  if (isLoading) return <Spin />

  return (
    <Space
      orientation="vertical"
      className="w-full"
      style={{ maxHeight: 250, overflowY: 'scroll' }}
    >
      <Text>Referral tree</Text>
      <Tree
        showLine
        treeData={[
          {
            title: <User.Avatar size={25} model={user} />,
            key: '0-' + user?.id,
            children: (data ?? []).map((referred) => ({
              title: (
                <Space>
                  {referred.status === 'Pending' && (
                    <Space>
                      <Tag>{referred.status}</Tag>
                      <Tag>{referred.phone}</Tag>
                    </Space>
                  )}
                  {referred.status === 'Registered' && (
                    <User.Avatar size={25} model={referred.referred} />
                  )}
                </Space>
              ),
              key: `0-${user?.id}-${referred.id}`,
            })),
          },
        ]}
        switcherIcon={<DownOutlined />}
        defaultExpandedKeys={[`0-${user?.id}`]}
      />
    </Space>
  )
}

type LoyaltyReferredUsersType = {
  LoyaltyReferredUsers: typeof LoyaltyReferredUsers
}

export { LoyaltyReferredUsers, type LoyaltyReferredUsersType }
